import React from 'react';
import { Check } from 'lucide-react';
import { professorData } from '../mock';
import Header from '../components/Header';
import Footer from '../components/Footer';

export const SobrePage = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-4xl md:text-6xl font-serif font-bold mb-6">
                  Sobre o Professor
                </h1>
                <p className="text-xl text-[#B49163]">
                  {professorData.name}
                </p>
              </div>
              
              <div className="flex justify-center">
                <div className="w-full max-w-md">
                  <img 
                    src={professorData.photo}
                    alt={professorData.name}
                    className="w-full h-auto rounded-2xl shadow-2xl object-cover border-4 border-[#B49163]"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-16 md:py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0F172A] mb-8 text-center">
              História e Superação
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed text-center">
              {professorData.story}
            </p>
          </div>
        </section>

        {/* Bio and Highlights Section */}
        <section className="py-16 md:py-20 bg-[#F8FAFC]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12">
              {/* Bio Summary Block */}
              <div className="space-y-6">
                <div className="bg-white p-8 rounded-xl shadow-md border-l-4 border-[#B49163]">
                  <h3 className="text-2xl font-serif font-semibold text-[#0F172A] mb-4">
                    Formação e Experiência
                  </h3>
                  <p className="text-lg text-gray-700 leading-relaxed">
                    {professorData.bio.summary}
                  </p>
                </div>
              </div>

              {/* Highlights Block */}
              <div className="space-y-6">
                <div className="bg-white p-8 rounded-xl shadow-md">
                  <h3 className="text-2xl font-serif font-semibold text-[#0F172A] mb-6">
                    Destaques da Carreira
                  </h3>
                  <ul className="space-y-4">
                    {professorData.bio.highlights.map((highlight, index) => (
                      <li key={index} className="flex items-start gap-3">
                        <Check className="text-[#B49163] flex-shrink-0 mt-1" size={24} />
                        <span className="text-lg text-gray-700">{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default SobrePage;